<template>
    <div id="pageTable">
        <v-container grid-list-xl fluid>
            <v-layout row wrap>
                <v-flex
                        class="-mouse-pointer"
                        :key="store.id"
                        v-for="(store,_) in stores"
                        md4 xs4>
                    <router-link class="store-text" :to="`/pages/store/edit/` + store.shop_id">
                        <v-card>
                            <v-img :src="`/stores/` + store.picture" style="margin: 0 auto;" width="256" height="256">
                            </v-img>
                            <v-divider></v-divider>
                            <v-card-actions>
                                <v-btn flat class="info" block large>{{store.shop_name}}</v-btn>
                            </v-card-actions>
                        </v-card>
                    </router-link>
                </v-flex>
            </v-layout>
            <v-snackbar
                    :timeout="snackbar.timeout"
                    :color="snackbar.color"
                    :top="snackbar.y === 'top'"
                    :bottom="snackbar.y === 'bottom'"
                    :right="snackbar.x === 'right'"
                    :left="snackbar.x === 'left'"
                    :multi-line="snackbar.mode === 'multi-line'"
                    :vertical="snackbar.mode === 'vertical'"
                    v-model="snackbar.snackbar"
            >
                {{ snackbar.text }}
                <v-btn flat icon dark @click.native="snackbar.snackbar = false">
                    <v-icon>close</v-icon>
                </v-btn>
            </v-snackbar>
        </v-container>
    </div>
</template>

<script>
import HttpErrorToSnackbar from '@/api/HttpErrorToSnackbar';

export default {
  data () {
    return {
      snackbar: {
        snackbar: false,
        y: 'top',
        x: 'right',
        mode: 'multi-line',
        timeout: 6000,
        color: 'error',
        text: ''
      },
      stores: [],
    };
  },
  created: function () {
    this.axios.get('/reseller/stores/')
      .then(response => {
        this.stores = response.data.Data;
        if (this.stores.length === 1) {
          this.$router.push('/pages/store/edit/' + this.stores[0].shop_id);
        }
      })
      .catch(error => {
        this.snackbar = HttpErrorToSnackbar(error);
      });
  }
};
</script>
<style>
    .store-text{
        text-decoration: none;
        text-shadow: 1px 1px 1px #818181;
    }
</style>



// WEBPACK FOOTER //
// src/pages/store/modify.vue